import  {initializeApp} from "firebase/app"
import {getAuth } from "firebase/auth";
const firebaseConfig = {
    apiKey: "AIzaSyAZkNgGo3Crshj2IAVhqv2Zpy2tX94xwXo",
    authDomain: "e-sako.firebaseapp.com",
    databaseURL: "https://e-sako-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "e-sako",
    storageBucket: "e-sako.appspot.com",
    messagingSenderId: "26177947593",
    appId: "1:26177947593:web:26c901370fd81cc7098a18"
  };

// Initialize Firebase
initializeApp(firebaseConfig);
const myauth = getAuth()


export const Auth = myauth